module.exports = __webpack_public_path__ + "img/انتزاعی .23b2cd2c.jpg";